import { Typography } from 'antd';

import LookForEServiceCard from './LookForEServiceCard';
import type { IEservicesGroup } from '../types/eservices';

const { Text, Title } = Typography;

interface LookForEServicesActiveSectionProps extends IEservicesGroup {
  showTitle: boolean;
}

const LookForEServicesActiveSection = ({
  description,
  label,
  modules,
  showTitle = true,
}: LookForEServicesActiveSectionProps) => (
  <div className="flex flex-col gap-2 lg:gap-6">
    {!!showTitle && (
      <div className="flex flex-col">
        <Title className="m-0 ml-2 text-base text-primary-blue-grey lg:ml-0 lg:text-xl" lang="en" level={5}>
          {label}
        </Title>
        <Text className="hidden text-base text-primary-blue-grey lg:block" lang="en">
          {description}
        </Text>
      </div>
    )}
    <div className="grid auto-rows-fr grid-cols-1 gap-2 lg:grid-cols-3 lg:gap-6">
      {modules.map(({ description, icon, label, onClick, publicDescription, publicUrl, url }) => (
        <LookForEServiceCard
          description={description}
          icon={icon}
          key={label}
          label={label}
          onClick={onClick}
          publicDescription={publicDescription}
          publicUrl={publicUrl}
          url={url}
        />
      ))}
    </div>
  </div>
);

export default LookForEServicesActiveSection;
